import { firebaseService } from './FirebaseService';

class FirebaseTranslationService {
    static instance = new FirebaseTranslationService();


    async translateText(text, targetLang) {
        if (!text || targetLang === 'en') return text;

        try {
            const translatedText = await firebaseService.translateText(text, targetLang);
            return translatedText;
        } catch (error) {
            console.error('Translation error:', error);
            return text;
        }
    }

    async translateMELContent(modelData, targetLang) {
        if (targetLang === 'en') return modelData;

        try {
            const translations = {};
            const translatedModel = { ...modelData };
            const translationPromises = [];

            if (translatedModel.nodes) {
                translatedModel.nodes.forEach(node => {
                    // Create promises but don't await them yet
                    translationPromises.push(
                        Promise.all([
                            firebaseService.translateText(node.id, targetLang),
                            firebaseService.translateText(node.description, targetLang)
                        ]).then(([translatedTitle, translatedDesc]) => {
                            translations[node.id] = {
                                title: translatedTitle,
                                description: translatedDesc
                            };
                            node.display = {
                                title: translatedTitle,
                                description: translatedDesc
                            };
                        })
                    );
                });


                // Wait for all translations with timeout
                await Promise.race([
                    Promise.all(translationPromises),
                    new Promise((_, reject) =>
                        setTimeout(() => reject(new Error('Translation batch timeout')), 30000)
                    )
                ]);
            }

            return translatedModel;
        } catch (error) {
            console.error('Translation batch error:', error);
            // Return original model on error
            return modelData;
        }
    }
}

export const translationService = FirebaseTranslationService.instance;